var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icons",
    viewBox: "0 0 60 60",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.984,28.636A3.5,3.5,0,0,0,42,27.619V8c0-5.2-10.819-8-21-8S0,2.8,0,8V44c0,5.2,10.819,8,21,8,.4,0,.817-.008,1.234-.016l-1.691,2.67a3.422,3.422,0,0,0-.109,3.527A3.483,3.483,0,0,0,23.527,60H56.473a3.483,3.483,0,0,0,3.093-1.819,3.422,3.422,0,0,0-.109-3.527ZM21,2C32.2,2,40,5.162,40,8s-7.8,6-19,6S2,10.838,2,8,9.8,2,21,2ZM2,11.561C5.591,14.464,13.468,16,21,16s15.409-1.536,19-4.439V20c0,2.838-7.8,6-19,6S2,22.838,2,20Zm0,12C5.591,26.464,13.468,28,21,28s15.409-1.536,19-4.439V27a3.508,3.508,0,0,0-2.984,1.636l-5.2,8.221A48.624,48.624,0,0,1,21,38C9.8,38,2,34.838,2,32ZM21,50C9.8,50,2,46.838,2,44V35.561C5.591,38.464,13.468,40,21,40a53.1,53.1,0,0,0,9.324-.8l-6.8,10.735C22.659,49.977,21.807,50,21,50Zm36.814,7.216A1.506,1.506,0,0,1,56.473,58H23.527a1.506,1.506,0,0,1-1.341-.784,1.429,1.429,0,0,1,.046-1.491L38.705,29.706a1.541,1.541,0,0,1,2.59,0L57.768,55.725A1.429,1.429,0,0,1,57.814,57.216Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41,35H39a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V37A2,2,0,0,0,41,35ZM39,46V37h2l0,9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40,50a3,3,0,1,0,3,3A3,3,0,0,0,40,50Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,40,54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.576,19.106c.335.157.689.308,1.057.454a1,1,0,0,0,.734-1.86q-.494-.195-.943-.406a1,1,0,0,0-.848,1.812Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.773,20.82q.505.119,1.03.224a.955.955,0,0,0,.2.019,1,1,0,0,0,.2-1.98c-.33-.066-.653-.137-.97-.21a1,1,0,1,0-.454,1.947Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.25927ab93887b49f6e92f1a6c234d421.svg";
export { ForwardRef as ReactComponent };